import { useState } from "react";
import "./cart.css";

function Cart() {
  // Ejemplo de items en el carrito.
  const [cartItems, setCartItems] = useState([
    {
      id: 1,
      name: "Plan Asesoría",
      description: "Sesión de 1 hora de asesoría personalizada",
      price: 100,
      quantity: 1,
    },
    {
      id: 2,
      name: "Plan Emprendimiento",
      description: "Acceso a herramientas y mentoría de negocio",
      price: 200,
      quantity: 2,
    },
  ]);

  // Estado para el código promocional
  const [promoCode, setPromoCode] = useState("");

  // Cálculo del subtotal
  const subtotal = cartItems.reduce(
    (acc, item) => acc + item.price * item.quantity,
    0
  );

  // Manejo de aplicar código (ejemplo)
  const handleApplyPromo = () => {
    if (promoCode.toLowerCase() === "descuento10") {
      alert("¡Código aplicado! (demo)");
      // Aquí podrías aplicar un descuento real al subtotal
    } else {
      alert("Código inválido o expirado");
    }
  };

  // Botón de “Continuar Explorando”
  const handleContinue = () => {
    // Ejemplo: Redirigir a otra página
    alert("Continuar explorando (demo)");
  };

  // Botón de “Proceder al Pago”
  const handleCheckout = () => {
    alert("Proceder al pago (demo)");
  };

  // Funciones para cambiar cantidad
  const handleIncrement = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, quantity: item.quantity + 1 }
          : item
      )
    );
  };

  const handleDecrement = (id) => {
    setCartItems((prev) =>
      prev.map((item) =>
        item.id === id
          ? {
              ...item,
              quantity: item.quantity > 1 ? item.quantity - 1 : 1,
            }
          : item
      )
    );
  };

  // Eliminar un producto del carrito
  const handleRemove = (id) => {
    setCartItems((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <div className="cart-page-container">
      <h1 className="cart-page-title">CARRITO</h1>
      <p className="cart-page-subtitle">
        Revisa los servicios o productos que seleccionaste antes de completar tu compra.
      </p>

      {cartItems.length === 0 ? (
        <div className="empty-cart">
          <p>Tu carrito está vacío</p>
        </div>
      ) : (
        <>
          <div className="cart-table-wrapper">
            <table className="cart-table">
              <thead>
                <tr>
                  <th>Productos</th>
                  <th>Descripción</th>
                  <th>Cantidad</th>
                  <th>Precio (US$)</th>
                  <th>Subtotal</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {cartItems.map((item) => {
                  const itemSubtotal = item.price * item.quantity;
                  return (
                    <tr key={item.id}>
                      <td>{item.name}</td>
                      <td>{item.description}</td>
                      <td>
                        <button
                          className="btn-qty"
                          onClick={() => handleDecrement(item.id)}
                        >
                          -
                        </button>
                        <span className="item-quantity">{item.quantity}</span>
                        <button
                          className="btn-qty"
                          onClick={() => handleIncrement(item.id)}
                        >
                          +
                        </button>
                      </td>
                      <td>{item.price.toFixed(2)}</td>
                      <td>{itemSubtotal.toFixed(2)}</td>
                      <td>
                        <button
                          className="btn-remove"
                          onClick={() => handleRemove(item.id)}
                        >
                          Eliminar
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="4" className="tfoot-label">Subtotal</td>
                  <td colSpan="2" className="tfoot-value">
                    ${subtotal.toFixed(2)}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>

          <div className="promo-section">
            <label htmlFor="promo-input" className="promo-label">
              Código Promocional:
            </label>
            <input
              id="promo-input"
              type="text"
              className="promo-input"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              placeholder="Ingresa tu código"
            />
            <button className="btn-apply-promo" onClick={handleApplyPromo}>
              APLICAR CÓDIGO
            </button>
          </div>

          <div className="cart-actions">
            <button className="btn-continue" onClick={handleContinue}>
              CONTINUAR EXPLORANDO
            </button>
            <button className="btn-checkout" onClick={handleCheckout}>
              PROCEDER AL PAGO
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default Cart;